import { authService } from "../firebase";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faTwitter } from "@fortawesome/free-brands-svg-icons";

const Profile = ({ refreshUser, userObj }) => {
    const history = useHistory();
    const [newDisplayName, setNewDisplayName] = useState(userObj.displayName);
    const onLogOutClick = () => {
        authService.signOut();
        history.push("/");
    };
    const onChange = (event) => {
        const {
            target: { value },
        } = event;
        setNewDisplayName(value);
    };
    const onSubmit = async (event) => {
        event.preventDefault();
        if (userObj.displayName !== newDisplayName) {
            await userObj.updateProfile({
                displayName: newDisplayName,
            });
            refreshUser();
        }
    };

    return (
        <div className="container">
            <form onSubmit={onSubmit} className="profileForm">
                <input
                    onChange={onChange}
                    type="text"
                    autoFocus
                    placeholder="Display name"
                    value={newDisplayName}
                    className="formInput"
                />
                <input
                    type="submit"
                    value="Update Profile"
                    className="formBtn"
                    style={{
                        marginTop: 10,
                    }}
                />
            </form>
            <span className="formBtn cancelBtn logOut" onClick={onLogOutClick}>
                Log Out
            </span>
            <nav>
                <ul style={{ display: "flex", justifyContent: "center", marginTop: 50 }}>
                    <li>
                        <a href="https://www.facebook.com/Snowballlol-101320455265174" style={{ marginRight: 15 }}>
                            <FontAwesomeIcon icon={faFacebook} color={"#fdffbc"} size="3x" />
                        </a>
                    </li>
                    <li>
                        <a
                            href="https://twitter.com/SnowballlolM?lang=ko"
                            style={{ marginLeft: 15 }}
                        >
                            <FontAwesomeIcon icon={faTwitter} color={"#fdffbc"} size="3x" />
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    );
};

export default Profile